import { addClass } from './classes';
/**
 * Create a DOM element
 */
export function createElement(
/**
 * TagName
 */
selector, 
/**
 * Element properties
 */
prop = {}) {
    // create an element
    const el = document.createElement(selector);
    // add classes
    if (prop.class) {
        addClass(el, prop.class);
    }
    // add id
    if (prop.id) {
        el.setAttribute('id', prop.id);
    }
    // add attributes
    if (prop.attr) {
        for (let i = 0, l = prop.attr.length; i < l; i++) {
            const attrInfo = prop.attr[i];
            el.setAttribute(attrInfo[0], attrInfo[1]);
        }
    }
    // append to parent
    if (prop.parent) {
        prop.parent.appendChild(el);
    }
    // add html
    if (prop.html) {
        el.innerHTML = prop.html;
    }
    // add children
    if (prop.children) {
        for (let i = 0, l = prop.children.length; i < l; i++) {
            el.appendChild(prop.children[i]);
        }
    }
    // return the element
    return el;
}
